import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

/** Matches MuiOutlinedInput-sizeSmall height (40px). */
const INPUT_HEIGHT = 40;

const outlinedBorder = (theme) =>
  theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';

/**
 * Compact Incl. / Excl. VAT toggle. Always visible; no extra caption (use column headers where needed).
 */
function PriceTaxToggle({ value = false, onChange, disabled = false, fullWidth = true }) {
  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      fullWidth={fullWidth}
      value={value ? 'incl' : 'excl'}
      onChange={(_, next) => {
        if (next) onChange(next === 'incl');
      }}
      disabled={disabled}
      sx={(theme) => ({
        display: 'flex',
        width: fullWidth ? '100%' : 'auto',
        height: INPUT_HEIGHT,
        boxSizing: 'border-box',
        border: `1px solid ${outlinedBorder(theme)}`,
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
        padding: 0,
        // Reset MUI grouped overlap (-1px margin + per-button borders)
        '& .MuiToggleButtonGroup-grouped': {
          margin: 0,
          border: 'none',
          borderRadius: 0,
          '&:not(:first-of-type)': {
            marginLeft: 0,
            borderLeft: `1px solid ${outlinedBorder(theme)}`
          }
        },
        '& .MuiToggleButton-root': {
          flex: 1,
          height: INPUT_HEIGHT,
          minHeight: INPUT_HEIGHT,
          py: 0,
          px: 0.5,
          fontSize: '0.8125rem',
          lineHeight: 1,
          textTransform: 'none',
          color: theme.palette.text.secondary,
          backgroundColor: 'transparent',
          border: 'none',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          },
          '&.Mui-selected': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            border: 'none',
            '&:hover': {
              backgroundColor: theme.palette.primary.dark
            }
          }
        }
      })}
    >
      <ToggleButton value="incl">Incl.</ToggleButton>
      <ToggleButton value="excl">Excl.</ToggleButton>
    </ToggleButtonGroup>
  );
}

export default PriceTaxToggle;
